'use client';

import cn from 'classnames';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import styles from './schedule.module.scss';
import { toLocalTimezone } from '@/packages/dateTime';
import { SafeHtml } from '@/components/atoms/Display';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { AudioIcon } from '@/ui-components/atoms/AnimatedIcons/AudioIcon/AudioIcon';

interface ScheduleItemProps {
    scheduleDate?: Date;
    title?: string;
    description?: string;
    children?: React.ReactNode | React.ReactNode[];
    isNowPlaying?: boolean;
    timeZone?: string;
}

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Schedule(props: ScheduleItemProps): React.JSX.Element {
    const nowPlayingClass = cn(styles.scheduleNowPlaying, {
        [styles.active]: props.isNowPlaying,
    });

    const timeString = getTimeString(props.scheduleDate, props.timeZone);

    return (
        <div className={styles.scheduleLineup}>
            <Grid container>
                <Grid col={{ sm: 4, md: 1 }}>
                    <span className={styles.scheduleTime}>{timeString}</span>
                </Grid>
                <Grid col={{ sm: 8, md: 11 }}>
                    <div className={nowPlayingClass}>
                        <span className={styles.nowPlayingSpan}>
                            <p>Now Playing</p>
                        </span>
                        <AudioIcon></AudioIcon>
                    </div>
                    <div>
                        <span className={styles.scheduleItemTitle}>{props.title}</span>
                        <SafeHtml tag="span" className={styles.scheduleItemDesc} print={props.description} />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

function getTimeString(scheduleDate: Date | undefined, timeZone?: string) {
    if (!scheduleDate) return '';
    const localDate = timeZone ? dayjs(scheduleDate).tz(timeZone) : dayjs(toLocalTimezone(scheduleDate));
    const localTimeString = localDate?.minute() === 0 ? localDate.format('h a') : localDate?.format('h:mm a');

    return localTimeString;
}
